import React from 'react';
import { PageLayout } from '../components/layout/PageLayout';

const posts = [
  {
    category: "Engineering",
    title: "How We Process $50B in Transactions with Sub-200ms Latency",
    excerpt: "A deep dive into our distributed transaction pipeline, intelligent routing engine, and the architecture decisions that keep Paygent fast at scale.",
    date: "April 18, 2026",
    readTime: "12 min read",
    color: "#2563EB",
  },
  {
    category: "Security",
    title: "Beyond PCI: Our Multi-Layered Approach to Payment Security",
    excerpt: "PCI DSS Level 1 is the baseline. Here's how Radar's AI fraud engine, P2PE encryption, and network tokenization create defense in depth.",
    date: "April 10, 2026",
    readTime: "8 min read",
    color: "#EF4444",
  },
  {
    category: "Product",
    title: "Introducing Tapn: Turn Any Smartphone Into a POS Terminal",
    excerpt: "No hardware, no setup fees. Tapn uses NFC tap-to-pay technology to let your staff accept contactless payments from their personal devices.",
    date: "April 2, 2026",
    readTime: "5 min read",
    color: "#0D9488",
  },
  {
    category: "Industry",
    title: "The End of Legacy POS: Why Hospitality Is Going Cloud-First",
    excerpt: "Festivals, hotels, and restaurants are ditching expensive hardware in favor of software-based payment acceptance. Here's the data behind the shift.",
    date: "March 25, 2026",
    readTime: "7 min read",
    color: "#F59E0B",
  },
  {
    category: "Engineering",
    title: "Building a Real-Time Fraud Scoring Engine with Gemini AI",
    excerpt: "How we integrated Google's Gemini models into our risk scoring pipeline to catch fraud patterns that rule-based systems miss.",
    date: "March 15, 2026",
    readTime: "10 min read",
    color: "#7C3AED",
  },
  {
    category: "Company",
    title: "Paygent Closes $12M Series A to Expand Enterprise Payments",
    excerpt: "We're scaling our team and infrastructure to serve more enterprise merchants across North America and Europe.",
    date: "March 1, 2026",
    readTime: "3 min read",
    color: "#2563EB",
  },
];

export default function Blog() {
  return (
    <PageLayout
      title="Blog"
      subtitle="Engineering insights, product updates, and the future of payment infrastructure."
      badge="INSIGHTS"
    >
      <div className="max-w-5xl mx-auto">
        {/* Featured Post */}
        <div className="bg-gradient-to-br from-blue-600 to-indigo-700 rounded-[2rem] p-10 md:p-14 text-white mb-12 shadow-xl">
          <span className="text-xs font-bold uppercase tracking-widest text-blue-200">{posts[0].category}</span>
          <h2 className="text-3xl md:text-4xl font-extrabold mt-3 mb-4 leading-tight">{posts[0].title}</h2>
          <p className="text-blue-100 text-lg mb-6 max-w-2xl">{posts[0].excerpt}</p>
          <div className="flex items-center gap-4 text-blue-200 text-sm">
            <span>{posts[0].date}</span>
            <span>·</span>
            <span>{posts[0].readTime}</span>
          </div>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {posts.slice(1).map(post => (
            <article key={post.title} className="bg-white rounded-2xl border border-gray-100 p-6 hover:shadow-lg transition-shadow cursor-pointer group">
              <span className="text-xs font-bold uppercase tracking-widest" style={{ color: post.color }}>{post.category}</span>
              <h3 className="text-lg font-bold text-gray-900 mt-2 mb-3 leading-snug group-hover:text-blue-600 transition-colors">{post.title}</h3>
              <p className="text-sm text-gray-500 leading-relaxed mb-4">{post.excerpt}</p>
              <div className="flex items-center gap-3 text-xs text-gray-400">
                <span>{post.date}</span>
                <span>·</span>
                <span>{post.readTime}</span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </PageLayout>
  );
}
